import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class OutreachLocation extends ApplicationRecord {
  static jsonapiType = "outreach_locations";

  @HasMany() children: OutreachLocation[];

  @Attr() locationType: string;

  @Attr() name: string;

  @BelongsTo() parent: OutreachLocation;

  @Attr() parentId: number;

  @Attr() selfAndParentIds: number[];

  @Attr() selfAndParentNames: string[];

  @Attr() visible: boolean;
}

export default OutreachLocation;
